<ng-container *ngIf="!isLogged">
  <h6 *ngIf="!modal" class="mt-5">
    <div class="d-flex flex-column">
      <span>{{ 'login.info-line-1' | translate }}</span>
      <div class="d-flex align-items-center" style="gap: 0.5rem">
        <button class="btn btn-link px-0 m-0" (click)="showLoginPanel = !showLoginPanel">
          <h6 class="m-0 color-orange">
            {{ 'login.signin' | translate }}
          </h6>
        </button>
        <h6 class="m-0">{{ 'shared.or' | translate }}</h6>
        <button class="btn btn-link px-0 m-0" (click)="redirectTo('register')">
          <h6 class="m-0 color-orange">
            {{ 'login.register' | translate }}
          </h6>
        </button>
      </div>
    </div>
  </h6>

  <div *ngIf="modal || showLoginPanel" class="px-3">
    <form [formGroup]="loginForm" (submit)="onSubmit()" id="login-modal-form"
          (reset)="errorCode = null; formSubmitAttempt = false" class="d-flex flex-column mt-4">
      <div class="error text-end" *ngIf="errorCode !== null">
        <p [innerHTML]="'errors.' + errorCode | translate"></p>
      </div>

      <div class="form-group required w-100">
        <div class="d-flex align-items-center">
          <label for="email" class="form-control-description">{{ 'login.form.email' | translate }}</label>
          <div class="col-8 pe-0 ms-auto">
            <input type="text" class="form-control" id="email" formControlName="email" />
          </div>
        </div>
        <div class="help-block with-errors col-12 text-end"
             *ngIf="loginForm.get('email').invalid && formSubmitAttempt === true">
          <p *ngIf="loginForm.get('email')?.errors?.required">
            {{ 'errors.10005' | translate }}
          </p>
          <p *ngIf="loginForm.get('email')?.errors?.invalid">
            {{ 'errors.10102' | translate }}
          </p>
        </div>
      </div>

      <div class="form-group required w-100 mb-2">
        <div class="d-flex align-items-center">
          <label for="password" class="form-control-description">{{ 'login.form.password' | translate }}</label>
          <div class="col-8 pe-0 ms-auto">
            <app-password-input inputId="password" formControlName="password"></app-password-input>
          </div>
        </div>
        <div class="help-block with-errors col-12 text-end"
             *ngIf="loginForm.get('password').invalid && formSubmitAttempt === true">
          <p *ngIf="loginForm.get('password')?.errors?.required">
            {{ 'errors.10009' | translate }}
          </p>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center color-blue">
        <button class="btn btn-link" (click)="signInClick($event)">
          <span>{{ 'login.signin' | translate }}</span>
        </button>
        |
        <button class="btn btn-link" (click)="forgotPasswordClick($event)">
          <span>{{ 'login.forgotPassword' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</ng-container>

<app-loader *ngIf="loaderService.isLoading(loaderEnum.LOGIN)" [id]="loaderEnum.LOGIN"></app-loader>

<app-popup [isVisible]="showResetPasswordSuccessPopup">
  <h4 header>{{ 'personal.resetPassword.finalState.positive.title' | translate }}</h4>
  <div class="row pb-4">
    <div class="col-12">
      <div class="question">
        {{ 'personal.resetPassword.finalState.positive.content' | translate }}
      </div>
    </div>
  </div>
  <div class="row" footer>
    <div class="col-12 text-center">
      <button class="btn btn-default btn-navigation px-3 px-md-4 mb-sm-2"
              (click)="showResetPasswordSuccessPopup = !showResetPasswordSuccessPopup">
        {{ 'personal.button.ok' | translate | uppercase }}
      </button>
    </div>
  </div>
</app-popup>